import type { RouteLocationRaw } from "vue-router"

/**
 * Porte des pages d'alarmes (DEV-2252) : les alarmes sont réservées à l'offre
 * Energy Management (« pas d'alarmes si pas de suivi », décision D72 de la
 * refonte des alarmes), comme les routes d'api-metier qui les servent.
 *
 * Rend `true` si la page s'ouvre, sinon la destination de repli.
 */
export async function porteAlarmesEnergyManager(
    authStore: {
        isLogged: boolean
        userId?: string | null
        hasOfferEnergyManager: boolean
        fetchUser: () => Promise<unknown>
    },
    repli: RouteLocationRaw
): Promise<true | RouteLocationRaw> {
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
    return authStore.hasOfferEnergyManager ? true : repli
}
